import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useInputChange } from '../../helpers/useInputChange'
import { useTranslation } from 'react-i18next';
import { postJson } from '../../helpers/RequestsHelper';

const VerifyPhonePage = (props) => {


  const [phone, setPhone] = useState()
  const [code, setCode] = useInputChange(props.code)
  const [error, setError] = useState()
  const [codeResending, setCodeResending] = useState()
  const [codeSending, setCodeSending] = useState()
  const [codeSent, setCodeSent] = useState(true)
  const { t } = useTranslation()

  const history = useHistory();

  const cognitoUser = window.userPool.getCurrentUser()
  if (cognitoUser != null) {
    if (!phone) {
      cognitoUser.getSession(function (err, session) {
        cognitoUser.getUserAttributes(function (err, result) {
          const phoneAttribute = result.find(a => a.Name === "phone_number")
          setPhone(phoneAttribute.Value)
        })
      })
    }
  }

  const onSubmit = (e) => {
    e.preventDefault();
    let button = e.currentTarget;
    if (button.clicked) {
      return
    }
    button.clicked = true
    const verificationCode = code
    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, session) {
        if (err) {
          button.clicked = false
          setError(err.message)
          return;
        }
        cognitoUser.verifyAttribute('phone_number', verificationCode,
          {
            onSuccess() {

              postJson(process.env.REACT_APP_SERVER_BASE_URL + "/updateProfile", {});
            },
            onFailure(err) {
              button.clicked = false
              setError(err.message)
            }
          });
        history.push("/user/profile")
      })
    } else {
      button.clicked = false
    }
  }
  const onSend = (e) => {
    //   e.preventDefault();
    //   let button = e.currentTarget;
    //   button.disabled = true

    //   if (codeSending) {
    //     return
    //   }

    //   setTimeout(function () { button.disabled = false }, 10000);

    //   setCodeSending(true)

    //   if (cognitoUser != null) {
    //     cognitoUser.getSession(function (err, session) {
    //       if (err) {
    //         setError(err.message)
    //         return;
    //       }
    //       cognitoUser.getAttributeVerificationCode('phone_number', {
    //         onSuccess: function (result) {
    //           setCodeSending(false)
    //           setCodeSent(true)
    //         },
    //         onFailure: function (err) {
    //           setCodeSending(false)
    //           setError(err.message)
    //         }
    //       })
    //     })
    //   }
  }

  const onResend = (e) => {
    e.preventDefault();
    let button = e.currentTarget;
    button.disabled = true

    if (codeResending) {
      return
    }

    setTimeout(function () { button.disabled = false }, 30000);

    setCodeResending(true)

    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, session) {
        if (err) {
          setError(err.message)
          return;
        }
        cognitoUser.getAttributeVerificationCode('phone_number', {
          onSuccess: function (result) {
            setCodeResending(false)
            setCodeSent(true)
          },
          onFailure: function (err) {
            setCodeResending(false)
            setError(err.message)
          }
        })
      })
    }
  }

  document.title = t("titleappname") + t("title_verify_phone")

  return <div className="wrap-login100">
    <form className="login100-form validate-form" onSubmit={onSubmit}>
      <h3>{t("title_verify_phone")}</h3>
      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_phone")}</span>
        <input className="input100"
          type="phone"
          name="phone"
          autoComplete="phone"
          id="phone"
          placeholder={t("tip_phone")}
          value={phone}
          onChange={setPhone}
          required={true}
          disabled={true} />
        <span className="focus-input100" data-symbol="&#xf3cd;"></span>
      </div>
      <br />


      {codeSent ?
        <>
          <div className="wrap-input100 validate-input">
            <span className="label-input100">{t("lbl_code")}</span>
            <input className="input100"
              type="text"
              name="code"
              autoComplete="off"
              id="code"
              placeholder={t("tip_code_phone")}
              value={code}
              onChange={setCode}
              required={true}
              pattern="^\d{6}$" title={t("val_code")} />
            <span className="focus-input100" data-symbol="&#xf292;"></span>
          </div>
          <br />
          {error ? <small id="errorMessage" className="text-danger">{error}<br /></small> : ""}
          <br />
          <div>
            <input type="submit" className="submit-btn" value={t("btn_confirmation_submit")} />
          </div>
          <br />
          <span>{t("lbl_resubmit_code")}</span>
          <br />
          <div>
            <input type="button" className="submit-btn-2" value={codeResending ? t("btn_confirmation_resending") : t("btn_confirmation_resend")} onClick={onResend} />
          </div>
        </>
        :
        <div>
          {error ? <small id="errorMessage" className="text-danger">{error}<br /></small> : ""}
          <br />
          <input type="button" className="submit-btn" value={t("btn_confirmation_send")} onClick={onSend} />
        </div>
      }
    </form>
  </div>
}

export default VerifyPhonePage
